/* eslint-disable no-useless-escape */
/* eslint-disable */

import axios from 'axios'
import { Auth } from 'aws-amplify'
import moment from 'moment'
import { REACT_APP_URL } from './authConfig'
import {
  formatPhoneNumber,
  handleSigners,
  splitBySpace,
  nullParser,
  convertToSentenceCase,
  cacheIt
} from '../services/utils'


const ADDRESS = process.env.REACT_APP_API_URL
const GROWER_ADDRESS = process.env.REACT_APP_GROWER_API_URL
const VERSION = 'v1'
export const signOut = () => {
  Auth.signOut()
    .then(() => {
      return null
    })
    .catch(err => console.error('signout fail:', err))
}

export const checkForUser = async () => {
  return Auth.currentAuthenticatedUser({
    bypassCache: false
  })
}

export const addNewUser = async email => {
  try {
    const response = await axios.post(
      `${ADDRESS}/company-management/${VERSION}/users`,
      {
        email
      }
    )
    return response.data.user_id
  } catch (error) {
    console.error('error: ', error)
    if (error.response) {
      return error.response
    }
    return error
  }
}

export const updateCompanyDetails = async (company_id, details) =>
  axios.patch(`${ADDRESS}/company-management/${VERSION}`, {
    company_id,
    details
  })

export const updateCompanyNonEnogen = async (
  company_id,
  allow_non_enogen_contracts
) => {
  try {
    let values = {
      company_id: company_id,
      allow_non_enogen_contracts: allow_non_enogen_contracts
    }
    const response = await axios.patch(
        `${ADDRESS}/company-management/${VERSION}`,
        values
    )
    return response
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const createOrUpdateCompany = async (
  country,
  company_name,
  company_type,
  address1,
  address2,
  city,
  state,
  zipcode,
  phone,
  isUpdate = false,
  company_id,
  sap_id,
  salesforce_id,
  inventory_code,
  supported_languages
) => {
  const mapResponseData = data => {
    data.country = nullParser(data.country)
    data.company_name = nullParser(data.company_name)
    data.address1 = nullParser(data.address1)
    data.address2 = nullParser(data.address2)
    data.city = nullParser(data.city)
    data.state = nullParser(data.state)
    data.zipcode = nullParser(data.zipcode)
    data.formatedPhone = formatPhoneNumber(data.phone)
    data.salesforce_id = nullParser(data.salesforce_id)
    data.sap_id = nullParser(data.sap_id)
    data.inventory_code = nullParser(data.inventory_code)
    data.supported_languages = nullParser(data.supported_languages)
    return data
  }
  try {
    let values = {
      country,
      company_name,
      company_type,
      address1,
      city,
      state,
      zipcode,
      phone,
      sap_id,
      salesforce_id,
      inventory_code,
      supported_languages
    }

    if (address2 && address2.length > 0) values['address2'] = address2

    if (isUpdate) {
      values.company_id = company_id
      const response = await axios.patch(
        `${ADDRESS}/company-management/${VERSION}`,
        values
      )
      if (response.data) {
        response.data = mapResponseData(response.data)
      }
      return response
    } else {
      const response = await axios.post(
        `${ADDRESS}/company-management/${VERSION}`,
        values
      )
      if (response.data) {
        response.data = mapResponseData(response.data)
      }
      return response
    }
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const updateUserProfile = async (user_id, first, last, phone) => {
  const postable = {
    user_id,
    first,
    last
  }

  if (phone) {
    postable.phone = phone
  }

  try {
    const response = await axios.patch(
      `${ADDRESS}/company-management/${VERSION}/users`,
      postable
    )
    return response
  } catch (error) {
    console.error('error: ', error)
    return error.response.data
  }
}

export const getUserProfile = async (id, _param) => {
  try {
    let param = 'email'
    switch (_param) {
      case 'cognito_username':
        param = 'cognito_username'
        break
      default:
        break
    }
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/users?${param}=${id}`
    )
    return {
      user_id: response.data.user_id,
      email: nullParser(response.data.email),
      first: nullParser(response.data.first),
      last: nullParser(response.data.last),
      phone: nullParser(response.data.phone),
      invite_complete: response.data.invite_complete
    }
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const getUserProfileByCongitoUsername = async (
  cognito_username,
  token
) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/users?cognito_username=${cognito_username}`,
      { headers: { 'x-user-token': token } }
    )
    return {
      user_id: response.data.user_id,
      email: nullParser(response.data.email),
      first: nullParser(response.data.first),
      last: nullParser(response.data.last),
      phone: nullParser(response.data.phone),
      invite_complete: response.data.invite_complete
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

export const getHighestRole = async () => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/my-highest-role`
    )
    return response.data
  } catch (error) {
    console.error('HIGHEST ROLE: ', error)
    return null
  }
}

export const getInventoryCodes = async year => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/inventory-code?year=${year}`
    )
    return response.data
  } catch (error) {
    console.error('INVENTORY CODE: ', error)
    return null
  }
}

export const getGrowerProfile = async email => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-profile/${VERSION}?email=${email}`
    )
    return response
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getContracts = async (contractID, masterID) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?contract_id=${contractID}&master_agreement_id=${masterID}`
    )
    return response
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getCompanies = async (limit, skip, isChecked) => {
  try {
    let responseArray = []

    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}${
      limit ? `?limit=${limit}` : ''
      }${skip ? `&skip=${skip}` : ''}${isChecked ? `&get_enogen_dealer_only=${isChecked}` : ''}`
    )
    if (response.data && response.data.companies) {
      responseArray = response.data.companies.map(company => {
        return {
          company_type: nullParser(company.company_type),
          detail: company,
          company_name: nullParser(company.company_name),
          sap_id: nullParser(company.sap_id),
          reseller_detail: company,
          company_id: company.company_id,
          address: nullParser(company.address1),
          city: nullParser(company.city),
          state: nullParser(company.state),
          phone: formatPhoneNumber(company.phone)
        }
      })
      return responseArray
    }
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getCompany = async (companyId, _param) => {
  try {
    let param = 'company_id'
    switch (_param) {
      case 'sap_id':
        param = 'sap_id'
        break
      default:
        break
    }
    const response = await axios.get(
      `${ADDRESS}/company-management/v1?${param}=${companyId}`
    )
    const companyData = { ...response.data }
    companyData.company_name = nullParser(companyData.company_name)
    companyData.address1 = nullParser(companyData.address1)
    companyData.address2 = nullParser(companyData.address2)
    companyData.city = nullParser(companyData.city)
    companyData.state = nullParser(companyData.state)
    companyData.zipcode = nullParser(companyData.zipcode)
    companyData.formatedPhone = formatPhoneNumber(companyData.phone)
    companyData.sap_id = nullParser(companyData.sap_id)
    companyData.inventory_code = nullParser(companyData.inventory_code)
    companyData.allow_non_enogen_contracts = nullParser(companyData.allow_non_enogen_contracts)
    return companyData
  } catch (error) {
    console.error('GET company: error ', error)
    return null
  }
}

export const getAssignments = async (id, _param) => {
  const param = _param ? _param : 'company_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/assignments?${param}=${id}`
    )
    if (param === 'user_id') {
      return response.data.assignments
    }
    return response.data.assignments.map(assignment => {
      const fname = assignment.first || 'N/A'
      const lname = assignment.last || 'N/A'
      return {
        user_id: assignment.user_id,
        nameObj: {
          name: `${nullParser(fname)} ${nullParser(
            lname
          )}`,
          user_id: assignment.user_id
        },
        first_name: nullParser(fname),
        last_name: nullParser(lname),
        phone: nullParser(assignment.phone),
        email: nullParser(assignment.email),
        role: nullParser(assignment.display_name),
        role_type: assignment.role_type,
        role_name: assignment.role_name,// Added role name
        permissions: nullParser(assignment.permissions)
      }
    })
  } catch (error) {
    console.error('GET ASSIGNMENTS: ', error)
    return null
  }
}

export const getUserRoles = async () => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/roles`
    )
    return response.data.roles.map(role => {
      return {
        role_name: convertToSentenceCase(nullParser(role.display_name)),
        role_type: nullParser(role.role_type),
        role_id: role.role_id
      }
    })
  } catch (error) {
    console.error('GET ROLE: error ', error)
    return null
  }
}

export const patchCompany = async payload => {
  try {
    const response = await axios.patch(
      `${ADDRESS}/company-management/${VERSION}`,
      payload
    )
    return response
  } catch (error) {
    console.error('error: ', error)
  }
}

export const getContractTemplateAndTypes = async (
  external_reference_id,
  return_schema
) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/template?external_reference_id=${external_reference_id}${
      return_schema ? `&return_schema=${return_schema}` : ''
      }`
    )
    let contract_types = []
    let languages = ['en']
    if (response.data.templates.length) {
      const template = response.data.templates[0]
      if (return_schema) {
        template.contract_details_schema.properties.display_details.properties.contract_type.enum.forEach(
          item => {
            contract_types.push({
              contract_type_id: item,
              value: convertToSentenceCase(item)
            })
          }
        )
        languages = [...new Set(response.data.templates.map(item => item.template_language))]
      }
      return {
        contract_template_id: template.contract_template_id,
        contract_types,
        languages,
        templates:response.data.templates
      }
    }
    throw new Error('Successful call but no templates')
  } catch (error) {
    console.error('GET Contract Templates: error ', error)
    return null
  }
}

export const getContractByProductionTemplateAndTypes = async (
  id,
  return_schema,
  _param,
  contractLanguage
) => {
  let param = _param ? _param : 'external_reference_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/template?${param}=${id}${return_schema ? `&return_schema=${return_schema}` : ''}`
    )
    let contract_types = []
    let languages = ['en']
    if (response.data.templates.length) {
      let template = response.data.templates.filter(item => item.template_language === contractLanguage)
      if(template) {
        template = template[0]
      } else {
        template = response.data.templates[0]
      }
      if (return_schema) {
        const template_schema = response.data.templates[0]
        template_schema.contract_details_schema.properties.display_details.properties.contract_type.enum.forEach(
          item => {
            contract_types.push({
              contract_type_id: item,
              value: convertToSentenceCase(item)
            })
          }
        )
        languages = [...new Set(response.data.templates.map(item => item.template_language))]
      }
      return {
        contract_template_id: template.contract_template_id,
        contract_types,
        languages,
        templates:response.data.templates
      }
    }
    throw new Error('Successful call but no templates')
  } catch (error) {
    console.error('GET Contract Templates: error ', error)
    return null
  }
}

export const getContractTypes = async () => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/type`
    )
    let contract_types = []
    const types = response.data.types
    types.forEach(item => {
      contract_types.push({
        id: item.contract_type_id,
        value: convertToSentenceCase(item.contract_type_name)
      })
    })
    return contract_types
  } catch (error) {
    console.error('GET Contract Templates: error ', error)
    return null
  }
}

export const getContractType = async contract_type_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/type?contract_type_id=${contract_type_id}`
    )
    let contract_type = {
      id: response.types.contract_type_id,
      value: response.types.contract_type_name
    }
    return contract_type
  } catch (error) {
    console.error('GET Contract Templates: error ', error)
    return null
  }
}

export const getContractTemplates = async (id, _param, production_plan_id) => {
  let param = _param ? _param : 'external_reference_id'
  param = production_plan_id ? 'production_plan_id' : param
  let value = production_plan_id ? production_plan_id : id
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/template?${param}=${value}`
    )
    return response.data.templates
  } catch (error) {
    console.error('GET Contract Templates: error ', error)
    return null
  }
}

export const getCompanyContracts = async (company_id, limit) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/search?limit=${limit}&global_search=${company_id}`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment.utc(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getCompanyContractsByYear = async (company_id, limit, year, offset, statusArr) => {
  try {
    const response = await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}/search?limit=${limit}&offset=${offset}`, 
      {
        "year": year,
        "global_search": company_id,
        "contract_status": statusArr
      }
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment.utc(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}
export const getUserContracts = async signer_external_reference_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?signer_external_reference_id=${signer_external_reference_id}`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}


export const sendToSign = async (signers, parent_contract_id, data) => {
  try {
    // Send to sign and await the result
    const sendToSignResult = await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}/signers`,
      { signers }
    );

    // Void the contract if parent_contract_id is provided
    if (parent_contract_id) {
      await axios.patch(
        `${ADDRESS}/grower-contracts/${VERSION}/void?contract_id=${parent_contract_id}`,
        data
      );
    }

    // Return signers data from the sendToSignResult
    return sendToSignResult.data.signers;

  } catch (error) {
    console.error('Error in sendToSign:', error);
    return null;
  }
}


export const getContractById = async contract_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?contract_id=${contract_id}`
    )

    if(response.data.contracts?.contract_details?.fields.length > 0){
      const field = response.data.contracts.contract_details.fields.map(
        data => {
          return {
            ...data,
            field_id: (data.field_id === 'TotalEnogenAcres')? 'total_enogen_acres_id':data.field_id
          } }
      )
      response.data.contracts.contract_details.fields = [...field]
    }

    return response.data.contracts
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getContractByIdWithIntialField = async contract_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?contract_id=${contract_id}`
    )

    if(response.data.contracts?.contract_details.initial_fields) {
      response.data.contracts.contract_details.fields.splice(0,response.data.contracts.contract_details.fields.length)
      response.data.contracts.contract_details.initial_fields.forEach(f=>{
        response.data.contracts.contract_details.fields.push(f)
      })
    }

    if(response.data.contracts?.contract_details?.fields.length > 0){
      const field = response.data.contracts.contract_details.fields.map(
        data => {
          return {
            ...data,
            field_id: (data.field_id === 'TotalEnogenAcres')? 'total_enogen_acres_id':data.field_id
          } }
      )
      response.data.contracts.contract_details.fields = [...field]

      if(response.data.contracts.contract_details.fields.length > 1) {
        response.data.contracts.contract_details.fields = response.data.contracts.contract_details.fields.filter(function(data) {
          return (data.field_id !=='total_enogen_acres_id')
        })

        var newArr = response.data.contracts.contract_details.fields.map(function (item) {
          if (item.planting_rate === null || item.planting_rate === 'null') {
            item.planting_rate = '0'
          }
          if (item.average_yield === null || item.average_yield === 'null') {
            item.average_yield = '0'
          }
          return item
        })
        response.data.contracts.contract_details.fields = [...newArr]
      }

    }

    return response.data.contracts
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getContractByIdWithDraft = async contract_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/drafts?contract_id=${contract_id}`
    )
    return response.data.contracts
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const postContractByIdWithDraft = async contract_id => {
  try {
    return await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}/drafts`, { contract_id }
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getSigners = async contract_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/signers?contract_id=${contract_id}`
    )
    return response.data.signers
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getUserByEmail = async email => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/signers?contract_id=${email}`
    )
    return handleSigners(response.data)
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const searchUsers = async (
  searchTerm,
  method = 'full_name' || 'email',
  limit
) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/user-search?${method}=${searchTerm}${
      limit ? `&limit=${limit}` : ''
      }`
    )
    return response.data.users.map(user => {
      return {
        name: `${nullParser(user.first)} ${nullParser(user.last)}`,
        user_first_name: `${nullParser(user.first)}`,
        user_last_name: `${nullParser(user.last)}`,
        user_id: user.user_id,
        user_address1: nullParser(user.address1),
        user_address2: nullParser(user.address2),
        user_city: nullParser(user.city),
        user_state: nullParser(user.state),
        user_zipcode: nullParser(user.zipcode),
        user_phone: nullParser(user.phone),
        user_email: nullParser(user.email)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const searchCompanies = async (searchTerm, limit) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/company-search?search_name=${searchTerm}${
      limit ? `&limit=${limit}` : ''
      }`
    )
    const companies = response.data.companies.map(company => {
      return {
        name: nullParser(company.company_name),
        company_id: company.company_id,
        company_sap_id: nullParser(company.sap_id),
        company_address1: nullParser(company.address1),
        company_address2: nullParser(company.address2),
        company_city: nullParser(company.city),
        company_state: nullParser(company.state),
        company_zipcode: nullParser(company.zipcode),
        company_phone: nullParser(company.phone),
        company_email: nullParser(company.email),
        company_city_state_zip: `${nullParser(company.city)} ${nullParser(
          company.state
        )}, ${nullParser(company.zipcode)}`
      }
    })
    return companies
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const searchCompaniesForCompanyPage = async (searchTerm, isChecked, limit) => {
  try {
    const response = await axios.get(`${ADDRESS}/company-management/${VERSION}/company-search?search_name=${searchTerm}${limit ? `&limit=${limit}` : ''}${isChecked ? `&get_enogen_dealer_only=${isChecked}` : ''}`)
    const companies = response.data.companies.map(company => {
      return {
        company_type: nullParser(company.company_type),
        detail: company,
        company_name: nullParser(company.company_name),
        sap_id: nullParser(company.sap_id),
        reseller_detail: company,
        company_id: company.company_id,
        address: nullParser(company.address1),
        city: nullParser(company.city),
        state: nullParser(company.state),
        phone: formatPhoneNumber(company.phone)
      }
    })
    return companies
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const searchCompaniesBySAP = async sapId => {
  let massageFunction = company => {
    return {
      name: nullParser(company.company_name),
      company_id: company.company_id,
      company_sap_id: nullParser(company.sap_id),
      company_address1: nullParser(company.address1),
      company_address2: nullParser(company.address2),
      company_city: nullParser(company.city),
      company_state: nullParser(company.state),
      company_zipcode: nullParser(company.zipcode),
      company_phone: nullParser(company.phone),
      company_email: nullParser(company.email),
      company_city_state_zip: `${nullParser(company.city)} ${nullParser(
        company.state
      )}, ${nullParser(company.zipcode)}`
    }
  }
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}?sap_id=${sapId}`
    )
    let companies = []
    if (response.data.length) {
      companies = response.data.companies.map(massageFunction)
    } else {
      companies = [{ ...response.data }].map(massageFunction)
    }
    return companies
  } catch (error) {
    console.error('searchCompaniesBySAP:', error)
    return null
  }
}

export const searchCompaniesByType = async (searchTerm, company_type) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/company-search?search_name=${searchTerm}&company-type=${company_type}&limit=100`
    )
    const singleType = company => {
      if (company.company_type === company_type) {
        return true
      } else {
        return false
      }
    }
    const multipleTypes = company => {
      let returnable = false
      company_type.forEach(type => {
        if (company.company_type === type) {
          returnable = true
        }
      })
      return returnable
    }
    const filterFunction =
      typeof company_type === 'string' ? singleType : multipleTypes
    const filteredCompanies = response.data.companies.filter(filterFunction)
    const companies = filteredCompanies.map(company => {
      return {
        company_name: nullParser(company.company_name),
        sap_id: nullParser(company.sap_id),
        company_id: nullParser(company.company_id),
        address1: nullParser(company.address1),
        address2: nullParser(company.address2),
        city: nullParser(company.city),
        state: nullParser(company.state),
        zipcode: nullParser(company.zipcode),
        phone: nullParser(company.phone),
        email: nullParser(company.email)
      }
    })
    return companies
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getSigner = async user_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/signers?external_reference_id=${user_id}`
    )
    const signerArray = response.data.map(entry => {
      return {
        contract_id: entry.contract_id,
        signer_name: `${nullParser(entry.first_name)} ${nullParser(
          entry.last_name
        )}`,
        email: nullParser(entry.email),
        phone: formatPhoneNumber(entry.phone)
      }
    })
    return signerArray
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getSignerAssignments = async user_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/assignments?user_id=${user_id}&with_companies=true`
    )

    let result = response.data.companies.map(company => {
      const company_id = company.company_id
      let role
      response.data?.assignments &&
        response.data.assignments.forEach(assignment => {
          if (assignment.company_id === company_id) {
            role = assignment.display_name
          }
        })
      return {
        company_id,
        company_name: {
          title: nullParser(company.company_name),
          id: company.company_id
        },
        company_type: nullParser(company.company_type),
        sap_id: nullParser(company.sap_id),
        phone: formatPhoneNumber(nullParser(company.phone, '--')),
        city: nullParser(company.city, '--'),
        state: nullParser(company.state, '--'),
        role: nullParser(role),
        zipcode: nullParser(company.zipcode, '--'),
        address: nullParser(company.address1, '--'),
        enogen_dealer: nullParser(company.enogen_dealer, '--')
      }
    })
    return result
  } catch (error) {
    console.error('Get Signer Assignments: ', error)
    return null
  }
}

export const getSignerRole = async user_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/assignments?user_id=${user_id}`
    )
    return response.data.assignments.map(assignment => {
      return {
        company_id: assignment.company_id,
        signer_role: nullParser(assignment.role_name)
      }
    })
  } catch (error) {
    console.error('Get Signer Roles: ', error)
    return null
  }
}

export const getRolesAndPermissions = async () => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/roles`
    )
    return response.data.roles.map(role => {
      const returnable = {
        role_name: convertToSentenceCase(nullParser(role.display_name)),
        role_type: convertToSentenceCase(nullParser(role.role_type)),
        date_created: moment(role.created).format('MMMM Do YYYY, h:mm:ss a'),
        role_id: role.role_id,
        permissions: role.permissions
      }
      cacheIt('returnable', returnable)
      return returnable
    })
  } catch (error) {
    console.error('Get Roles and Permissions: ', error)
    return null
  }
}

export const getAllPermissions = async () => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/permissions`
    )
    return response.data.permissions.map(permission => {
      return {
        permission_code: nullParser(permission.permission_code),
        permission_display_name: convertToSentenceCase(
          nullParser(permission.display_name)
        ),
        permission_id: permission.permission_id
      }
    })
  } catch (error) {
    console.error('Get Permissions: ', error)
    return null
  }
}

export const searchGrowers = async search_term => {
  try {
    const response = await axios.get(
      `${GROWER_ADDRESS}/grower-360/${VERSION}/search?query=${search_term}`
    )
    return (
      'searchGrowers',
      response.data.growers
        .map(grower => {
          const firstAndSecond = grower.grower_name
            ? splitBySpace(grower.grower_name)
            : ['', '']
          return {
            grower_address: grower.address,
            grower_phone: grower.phone,
            grower_email: grower.email,
            value: grower.grower_name,
            grower_first: firstAndSecond[0],
            grower_last: firstAndSecond[1],
            grower_sfdc_id: grower.salesforce_id,
            grower_sap_id: grower.sap_id,
            grower_id: nullParser(grower.grower_id)
          }
        })
        .filter(grower => {
          return !!grower.grower_sap_id
        })
    )
  } catch (error) {
    console.error('Search Growers: ', error)
    return null
  }
}

export const postNewRole = async (
  role_type,
  display_name,
  description,
  permissions
) => {
  try {
    const res = await axios.post(
      `${ADDRESS}/company-management/${VERSION}/roles`,
      role_type,
      display_name,
      description,
      permissions
    )
    return res
  } catch (error) {
    console.error('Error: ', error)
    return error.response
  }
}

export const getGrower = async (id, param) => {
  try {
    const _param = param ? param : 'salesforce_id'
    const response = await axios.get(
      `${GROWER_ADDRESS}/grower-360/${VERSION}?${_param}=${id}`
    )
    const reseller = response.data.reseller[0]
    const reseller_name = reseller ? reseller.reseller_name : ''
    const reseller_sap_id = reseller ? reseller.reseller_sap_id : ''
    const firstAndSecond = splitBySpace(response.data.grower_name)
    const grower = response.data
    return (
      'getGrower',
      {
        grower_name: nullParser(grower.grower_name),
        grower_first: nullParser(firstAndSecond[0]),
        grower_last: nullParser(firstAndSecond[1]),
        grower_address: nullParser(grower.address),
        grower_city: nullParser(grower.city),
        grower_state: nullParser(grower.state),
        grower_zipcode: nullParser(grower.zipcode),
        grower_phone: nullParser(grower.phone),
        grower_email: grower.email,
        grower_id: nullParser(grower.grower_id),
        grower_sfdc_id: _param === 'salesforce_id' ? id : grower.salesforce_id,
        grower_sap_id: grower.sap_id,
        reseller_name,
        reseller_sap_id
      }
    )
  } catch (error) {
    console.error('Get Grower by salesforce_id: ', error)
    return null
  }
}

export const getFieldsBySFDC_ID = async sfdc_id => {
  try {
    let response = {
      data:{
        fields:[]
      }
    }
    try{
      response = await axios.get(
        `${ADDRESS}/grower-fields/${VERSION}/fields-eluminate?grower_salesforce_id=${sfdc_id}`
      )
    } catch(er) {
      // eslint-disable-next-line no-console
      console.log(er)
    }
    try {
      const responseGrowMore = await axios.get(
        `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdc_id}`
      )
      responseGrowMore.data.fields.forEach(f=>{
        if(!response.data.fields.find(field => ((f.field_name === field.field_name) && (f.field_id !== field.field_id) && (f.farm_name === field.farm_name)))){
          response.data.fields.push(f)
        }
      })
    } catch(er) {
      // eslint-disable-next-line no-console
      console.log(er)
    }
    
    const farmsNameArray = []
    const dataObj = {}
    const farmArray = []
    const fields = response.data.fields.map(field => {
      const farm_name = field.farm_name
      const farm_id = field.farm_id
      const farmOfInterst = dataObj[farm_name]
      const dataArrayObj = {
        id: field.field_id,
        value: field.field_name,
        isChecked: false
      }
      if (farmOfInterst) {
        dataObj[farm_name].push(dataArrayObj)
      } else {
        farmsNameArray.push({ farm_name, farm_id })
        dataObj[farm_name] = [dataArrayObj]
      }
      return {
        field_id: field.field_id,
        field_name: field.field_name,
        field_acres: field.field_acres,
        farm_id: field.farm_id,
        field_boundary: field.field_boundary,
        aph: 0
      }
    })
    farmsNameArray.forEach(({ farm_name, farm_id }) => {
      farmArray.push({
        title: farm_name,
        farm_id,
        data: dataObj[farm_name]
      })
    })
    // eslint-disable-next-line no-sequences
    return 'getFieldsBySFDC_ID', { farmArray, fields }
  } catch (error) {
    return null
  }
}

export const getFieldsBySFDC_IDAndContractId = async (sfdc_id, contract_id) => {
  try {
    let response = {
      data:{
        fields:[]
      }
    }
    try{
      response = await axios.get(
        `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdc_id}`
      )
    } catch(er) {
      // eslint-disable-next-line no-console
      console.log(er)
    }
    try {
      const responseGrowMore = await axios.get(
        `${ADDRESS}/grower-fields/${VERSION}/fields-eluminate?grower_salesforce_id=${sfdc_id}`
      )
      responseGrowMore.data.fields.forEach(f=>{
        response.data.fields.push(f)
      })

      if(!contract_id) {
        let result = response.data.fields.reduce((acc,current)=>{
          const x = acc.find(item => ((item.field_name === current.field_name && item.farm_name === current.farm_name) || (item.field_id === current.field_id)))
          if (!x) {
            return acc.concat([current])
          } else {
            return acc
          }
        },[])
        response.data.fields = [...result]
      } else {
        try {
          const contractResponse = await axios.get(
            `${ADDRESS}/grower-contracts/${VERSION}?contract_id=${contract_id}`
          )
          let contractField = []
          if(contractResponse.data.contracts?.contract_details?.fields.length > 0){
            contractField = contractResponse.data.contracts.contract_details.fields.map(data=> data.field_id)
          }

          let result = response.data.fields.reduce((acc,current)=>{
            let indexOf = -1
            if(contractField.length > 0){
              indexOf = contractField.indexOf(current.field_id)
            }
            if(indexOf!==-1){
              const prevIndex = acc.find(item => (item.field_id === current.field_id))
              if(!prevIndex){
                acc = acc.filter(item => (!(item.field_name === current.field_name && item.farm_name === current.farm_name)))
                return acc.concat([current])
              } else { 
                return acc
              }
              
            } else {
              const x = acc.find(item => ((item.field_name === current.field_name && item.farm_name === current.farm_name) || (item.field_id === current.field_id)))
              if (!x) {
                return acc.concat([current])
              } else {
                return acc
              }
            }
          },[])
          response.data.fields = [...result]

        } catch(er) {
          // eslint-disable-next-line no-console
          console.log(er)
        }
      }
    } catch(er) {
      // eslint-disable-next-line no-console
      console.log(er)
    }
    
    const farmsNameArray = []
    const dataObj = {}
    const farmArray = []
    const fields = response.data.fields.map(field => {
      const farm_name = field.farm_name
      const farm_id = field.farm_id
      const farmOfInterst = dataObj[farm_name]
      const dataArrayObj = {
        id: field.field_id,
        value: field.field_name,
        isChecked: false
      }
      if (farmOfInterst) {
        dataObj[farm_name].push(dataArrayObj)
      } else {
        farmsNameArray.push({ farm_name, farm_id })
        dataObj[farm_name] = [dataArrayObj]
      }
      return {
        field_id: field.field_id,
        field_name: field.field_name,
        field_acres: field.field_acres,
        farm_id: field.farm_id,
        field_boundary: field.field_boundary,
        aph: 0
      }
    })
    farmsNameArray.forEach(({ farm_name, farm_id }) => {
      farmArray.push({
        title: farm_name,
        farm_id,
        data: dataObj[farm_name]
      })
    })
    // eslint-disable-next-line no-sequences
    return 'getFieldsBySFDC_IDAndContractId', { farmArray, fields }
  } catch (error) {
    return null
  }
}

export const updateRole = async (role_id, display_name, permissions) => {
  try {
    const response = await axios.patch(
      `${ADDRESS}/company-management/${VERSION}/roles`,
      role_id,
      display_name,
      permissions
    )
    return response
  } catch (error) {
    console.error('Error in edit role: ', error)
    return error.response
  }
}

export const replantplantingStewardship = async params => {
  try {
    return await axios.post(
      `${ADDRESS}/seed-stewardship/${VERSION}/replant`,
      params
    )
  } catch (error) {
    console.error('Error in replant: ', error)
    return error.response
  }
}

export const fieldLostplantingStewardship = async params => {
  try {
    return await axios.post(
      `${ADDRESS}/seed-stewardship/${VERSION}/fieldLost`,
      params
    )
  } catch (error) {
    console.error('Error in field lost: ', error)
    return error.response
  }
}

export const inviteUser = async (role_id, company_id, user_id) => {
  try {
    const response = await axios.post(
      `${ADDRESS}/company-management/${VERSION}/assignments`,
      role_id,
      company_id,
      user_id
    )
    return response.data
  } catch (error) {
    if (error.response && error.response.status === 400) {
      return error.response
    }
    console.error(error)
    return error
  }
}

export const changePhoneAndResend = async (phone, email, growerDeliveryChoice, contract_id, contract_signer_id) => {
  try {
    let growerDeliveryChoiceVal = growerDeliveryChoice.toLowerCase()
    if(growerDeliveryChoiceVal === 'email') {
      growerDeliveryChoiceVal = 'email'
      phone = ''
    } else {
      growerDeliveryChoiceVal = 'phone'
      email = ''
    }

    return await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/resend?contract_id=${contract_id}&email=${email}&phone=${phone}&contract_signer_id=${contract_signer_id}&delivery_choice=${growerDeliveryChoiceVal}`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const createNewContract = async contractData => {
  const {
    root,
    inventory_code,
    grain_receiver_details,
    reseller_details,
    grower_details,
    fields,
    delivery_schedule,
    cattle_info,
    storage
  } = contractData
  let _contractStart
  let _contractEnd
  if (root.contract_start && root.contract_end) {
    _contractEnd = moment(root.contract_end).toISOString()
    _contractStart = moment(root.contract_start).toISOString()
  } else {
    _contractEnd = moment([root.contract_year])
      .endOf('year')
      .subtract(1, 'day')
      .toISOString()
    _contractStart = moment([root.contract_year]).toISOString()
  }

  const newObj = {
    contract_template_id: root.contract_template_id,
    external_reference_id: root.external_reference_id,
    contract_start_execution: _contractStart,
    contract_end_execution: _contractEnd,
    contract_state: 'pending',
    notify_senders: true,
    parent_voided_contract_id: root.parent_voided_contract_id,
    contract_originated: 'GrowMore360',
    contract_history: {
      created_user_info: root?.userInfo
    },
    contract_details: {
      display_details: {
        production_plan_inventory_code: inventory_code,
        contract_type: root.contract_type,
        production_plan_id: root.production_plan_id,
        unit_size: 1234,
        training_id: 'us-enogen',
        harvest_transportation: 'Fake String',
        delivery_month: 'september',
        unit_type: 'bushels'
      },
      grain_receiver_details: {
        zipcode: grain_receiver_details.zipcode,
        sap_id: grain_receiver_details.company_id,
        address: grain_receiver_details.address1,
        address2: nullParser(grain_receiver_details.address2),
        city: grain_receiver_details.city,
        grain_receiver_id: grain_receiver_details.company_id,
        grain_receiver_name: grain_receiver_details.company_name,
        state: grain_receiver_details.state
      },
      reseller_details: {
        zipcode: reseller_details.zipcode,
        sap_id: reseller_details.sap_id,
        address: reseller_details.address1,
        address2: nullParser(reseller_details.address2),
        city: reseller_details.city,
        reseller_name: reseller_details.company_name,
        state: reseller_details.state,
        reseller_id: reseller_details.company_id
      },
      grower_details: {
        sap_id: grower_details.grower_sap_id,
        first: grower_details.grower_first,
        last: grower_details.grower_last,
        address: grower_details.grower_address,
        address2: nullParser(grower_details.grower_address2),
        city: grower_details.grower_city,
        zipcode: grower_details.grower_zipcode,
        state: grower_details.grower_state,
        phone: grower_details.grower_phone || 'N/A',
        email: grower_details.grower_email
      },
      storage: storage,
      fields: fields,
      cattle_info: cattle_info
    }
  }

  if (root?.parent_voided_contract_id && root?.parent_voided_contract_id!=='') {
    newObj.contract_history.amended_user_info = {
      ...root?.userInfo,
      system_name: 'GrowMore360'
    }
  }
  
  if (delivery_schedule?.length && root.contract_type !== 'fed-on-farm') {
    let filterDeliveryschedule = []
    delivery_schedule.forEach(data => {
      if(data.contract_acres !== 0 
        && data.contract_acres !== '0' 
        && data.contract_acres !== null
        && data.contract_acres !== ''
      ) {
        filterDeliveryschedule.push(data)
      }
    })
    newObj.contract_details.delivery_schedule = filterDeliveryschedule

  }

  try {
    const response = await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}`,
      newObj
    )
    return response.data
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}


export const createNewContractFieldSync = async (contractData, sfdcId) => {
  const {
    root,
    inventory_code,
    grain_receiver_details,
    reseller_details,
    grower_details,
    fields,
    delivery_schedule,
    cattle_info,
    storage
  } = contractData
  let _contractStart
  let _contractEnd
  if (root.contract_start && root.contract_end) {
    _contractEnd = moment(root.contract_end).toISOString()
    _contractStart = moment(root.contract_start).toISOString()
  } else {
    _contractEnd = moment([root.contract_year])
      .endOf('year')
      .subtract(1, 'day')
      .toISOString()
    _contractStart = moment([root.contract_year]).toISOString()
  }

  const newObj = {
    contract_template_id: root.contract_template_id,
    external_reference_id: root.external_reference_id,
    contract_language: root?.contract_language ? root?.contract_language : 'en',
    contract_start_execution: _contractStart,
    contract_end_execution: _contractEnd,
    contract_state: 'pending',
    notify_senders: true,
    parent_voided_contract_id: root.parent_voided_contract_id,
    contract_originated: 'GrowMore360',
    contract_history: {
      created_user_info: root?.userInfo
    },
    contract_details: {
      display_details: {
        production_plan_inventory_code: inventory_code,
        contract_type: root.contract_type,
        production_plan_id: root.production_plan_id,
        unit_size: 1234,
        training_id: 'us-enogen',
        harvest_transportation: 'Fake String',
        delivery_month: 'september',
        unit_type: 'bushels'
      },
      grain_receiver_details: {
        zipcode: grain_receiver_details.zipcode,
        sap_id: grain_receiver_details.company_id,
        address: grain_receiver_details.address1,
        address2: nullParser(grain_receiver_details.address2),
        city: grain_receiver_details.city,
        grain_receiver_id: grain_receiver_details.company_id,
        grain_receiver_name: grain_receiver_details.company_name,
        state: grain_receiver_details.state
      },
      reseller_details: {
        zipcode: reseller_details.zipcode,
        sap_id: reseller_details.sap_id,
        address: reseller_details.address1,
        address2: nullParser(reseller_details.address2),
        city: reseller_details.city,
        reseller_name: reseller_details.company_name,
        state: reseller_details.state,
        reseller_id: reseller_details.company_id
      },
      grower_details: {
        sap_id: grower_details.grower_sap_id,
        first: grower_details.grower_first,
        last: grower_details.grower_last,
        address: grower_details.grower_address,
        address2: nullParser(grower_details.grower_address2),
        city: grower_details.grower_city,
        zipcode: grower_details.grower_zipcode,
        state: grower_details.grower_state,
        phone: grower_details.grower_phone || 'N/A',
        email: grower_details.grower_email
      },
      storage: storage,
      fields: fields,
      cattle_info: cattle_info
    }
  }
  
  if (root?.parent_voided_contract_id && root?.parent_voided_contract_id!=='') {
    newObj.contract_history.amended_user_info = {
      ...root?.userInfo,
      system_name: 'GrowMore360'
    }
  }

  if (delivery_schedule?.length && root.contract_type !== 'fed-on-farm') {
    let filterDeliveryschedule = []
    delivery_schedule.forEach(data => {
      if(data.contract_acres !== 0 
        && data.contract_acres !== '0' 
        && data.contract_acres !== null
        && data.contract_acres !== ''
      ) {
        filterDeliveryschedule.push(data)
      }
    })
    newObj.contract_details.delivery_schedule = filterDeliveryschedule
  }

  let responseEluminateField = []
  try {
    responseEluminateField = await axios.get(
      `${ADDRESS}/grower-fields/${VERSION}/fields-eluminate?grower_salesforce_id=${sfdcId}`
    )
    responseEluminateField = responseEluminateField.data.fields
  } catch (error) {
    console.error('error: ', error)
  }

  let responseGrowMore = []
  try {
    responseGrowMore = await axios.get(
      `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdcId}`
    )
    responseGrowMore = responseGrowMore.data.fields
  } catch (error) {
    console.error('error: ', error)
  }

  let axiosArray = []
  if(fields && fields.length > 0 && responseEluminateField && responseEluminateField.length > 0 && responseGrowMore && responseGrowMore.length > 0) {
    fields.forEach(f=>{
      if(!responseGrowMore.find(field => ((f.field_id === field.field_id) && (f.field_id !== 'total_enogen_acres_id')))) {
        const filterData = responseEluminateField.find(field => ((f.field_id === field.field_id) && (f.field_id !== 'total_enogen_acres_id')))
        if (filterData) {
          let newPromise = axios({
            method: 'post',
            url: `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdcId}`,
            data: filterData
          })
          axiosArray.push(newPromise)
        } 
      }
    })
  }

  if(axiosArray.length > 0) {
    axios
      .all(axiosArray)
      .then(() => {
        axios.post(
        `${ADDRESS}/grower-contracts/${VERSION}`,
        newObj
        )
          .then(response => {
            return response.data
          })
      })
      .catch(error => {
        console.error('error: ', error)
        return null
      })
  } else {
    try {
      const response = await axios.post(
        `${ADDRESS}/grower-contracts/${VERSION}`,
        newObj
      )
      return response.data
    } catch (error) {
      console.error('error: ', error)
      return null
    }
  }
}

export const voidContract = async (contract_id, data) => {
  try {
    const response = await axios.patch(
      `${ADDRESS}/grower-contracts/${VERSION}/void?contract_id=${contract_id}`,
      data
    )
    return response
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getProductionPlan = async (id, _param, ignoreCU = false) => {
  let returnable
  let param = 'production_plan_id'
  switch (_param) {
    case 'company_id':
      param = 'external_reference_id'
      break
    case 'parent':
      param = 'parent_production_plan_id'
      break
    default:
      break
  }
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/production-plan?${param}=${id}${
      ignoreCU ? '&ignore_cu=true' : ''
      }`
    )

    if (response.data.production_plans) {
      returnable = response.data.production_plans
    } else {
      returnable = response.data
    }
    return returnable
  } catch (error) {
    console.error('Get Production Plan: ', error)
    return null
  }
}

export const createNewProductionPlan = async planData => {
  const {
    total_units,
    total_acres,
    aph,
    company_name,
    external_reference_id,
    company_id,
    delivery_location,
    monthly_units,
    parent_production_plan_id,
    contract_year,
    selected_contract_type,
    premium_type,
    inventory_code
  } = planData

  const newObj = {
    total_units,
    total_acres,
    aph,
    external_reference_id,
    company_id,
    company_name,
    delivery_location,
    monthly_units,
    contract_year,
    production_plan_extra: selected_contract_type,
    premium_type,
    inventory_code
  }

  if (parent_production_plan_id) {
    newObj.parent_production_plan_id = parent_production_plan_id
  }
  try {
    const response = await axios.post(
      `${ADDRESS}/grain-ops/${VERSION}/production-plan`,
      newObj
    )
    return response.data
  } catch (error) {
    console.error('error: ', error)
  }
}

export const patchProductionPlan = async (planData, production_plan_id) => {
  const {
    total_units,
    total_acres,
    aph,
    company_name,
    external_reference_id,
    delivery_location,
    monthly_units,
    parent_production_plan_id,
    contract_year,
    selected_contract_type,
    premium_type,
    company_id,
    inventory_code
  } = planData

  const newObj = {
    total_units,
    total_acres,
    aph,
    external_reference_id,
    company_name,
    delivery_location,
    monthly_units,
    contract_year,
    production_plan_extra: selected_contract_type,
    premium_type,
    company_id,
    inventory_code
  }

  if (parent_production_plan_id) {
    newObj.parent_production_plan_id = parent_production_plan_id
  }
  try {
    const response = await axios.patch(
      `${ADDRESS}/grain-ops/${VERSION}/production-plan?production_plan_id=${production_plan_id}`,
      newObj
    )
    return response.data
  } catch (error) {
    console.error('error: ', error)
  }
}

export const uploadContractTemplate = async (
  contract_type_id,
  external_reference_id,
  template_base64,
  template_name,
  template_language,
  production_plan_id
) => {
  const newObj = {
    contract_type_id,
    external_reference_id,
    template_base64,
    template_name,
    template_language,
    production_plan_id
  }

  try {
    const response = await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}/template`,
      newObj
    )
    return response.data
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const patchContractTemplate = async patchObj => {
  try {
    const response = await axios.patch(
      `${ADDRESS}/grower-contracts/${VERSION}/template`,
      patchObj
    )
    return response.data
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const postStewards = async args => {
  try {
    return await axios.post(`${ADDRESS}/seed-stewardship/${VERSION}`, args)
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const getStewards = async userID => {
  try {
    const response = await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/activity?steward_external_reference_id=${userID}`
    )
    return response.data.activities.map(item => {
      return {
        external_reference_id: nullParser(item.external_reference_id),
        growerName: nullParser(
          item.stewardship_activity.display_details.grower_name
        ),
        harvestYear: nullParser(
          item.stewardship_activity.display_details.harvest_year
        ),
        grainReceiver: nullParser(
          item.stewardship_activity.display_details.grain_receiver_name
        ),
        stewardshipActiveID: nullParser(item.stewardship_activity_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getStewardshipFields = async stewardshipActiveID => {
  try {
    let response = await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/activity?stewardship_activity_id=${stewardshipActiveID}`
    )
    
    if(response.data.stewardship_activity.fields.length > 1) {
      response.data.stewardship_activity.fields = response.data.stewardship_activity.fields.filter(function(data) {
        return (data.field_id !=='TotalEnogenAcres' && data.field_id !=='total_enogen_acres_id')
      })

      var newArr = response.data.stewardship_activity.fields.map(function (item) {
        if (item.planting_rate === null || item.planting_rate === 'null') {
          item.planting_rate = '0'
        }
        if (item.average_yield === null || item.average_yield === 'null') {
          item.average_yield = '0'
        }
        return item
      })
      response.data.stewardship_activity.fields = [...newArr]
      
    }

    const stewardData = response.data.stewards.map(obj => {
      return {
        name: `${nullParser(obj.first_name)} ${nullParser(obj.last_name)}`,
        phone: formatPhoneNumber(nullParser(obj.phone)),
        email: nullParser(obj.email),
        id: obj.external_reference_id
      }
    })
    const activities = response.data.stewardship_activity
    const plantingData = activities.fields.map(obj => {
      return {
        name: obj.field_name,
        id: obj.field_id,
        total_planted_acres: obj.activity?.planting.total_planted_acres || '',
        date: obj.activity?.planting.date || '',
        planting_rate: obj.activity?.planting.planting_rate || '',
        crop: obj.activity?.planting.crop || '',
        type: 'planting'
      }
    })
    const harvestData = activities.fields.map(obj => {
      return {
        name: obj.field_name,
        id: obj.field_id,
        total_acres: obj.activity?.harvest.total_acres || '',
        harvest_date: obj.activity?.harvest.harvest_date || '',
        yield_per_acre: obj.activity?.harvest.yield_per_acre || '',
        yield_per_acre_formatted: obj.activity?.harvest.yield_per_acre
          ? `${obj.activity?.harvest.yield_per_acre} ${
          obj.activity?.harvest.unit_type
            ? obj.activity?.harvest.unit_type === 'bushels'
              ? 'bu'
              : obj.activity?.harvest.unit_type
            : ''
          }`
          : '',
        total_harvest: obj.activity.harvest.total_harvest || '',
        total_harvest_formatted: obj.activity.harvest.total_harvest
          ? `${obj.activity.harvest.total_harvest} ${
          obj.activity.harvest.unit_type
            ? obj.activity.harvest.unit_type === 'bushels'
              ? 'bu'
              : obj.activity.harvest.unit_type
            : ''
          }`
          : '',
        type: 'harvest',
        unit_type: nullParser(obj.activity.harvest.unit_type, 'bu')
      }
    })

    const storageData = activities.storage_locations.map((obj, index) => {
      const cleanout_date = obj.cleanout_date
        ? moment(obj.cleanout_date).format('YYYY-MM-DD')
        : ''
      return {
        ...obj,
        cleanout_date,
        type: 'storage',
        id: `${index}-${obj.location_name}`
      }
    })
    const originalResponse = response
    return {
      originalResponse,
      stewardData,
      plantingData,
      harvestData,
      storageData,
      activities
    }
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

function convertDate(dateStr) {
  const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/
  if (datePattern.test(dateStr)) {
    const [month, day, year] = dateStr.split('/')
    return `${year}-${month}-${day}`
  } else {
    return dateStr;
  }
}

export const getStewardshipDefaultData = async stewardshipActiveID => {
  try {
    let response = await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/activity?stewardship_activity_id=${stewardshipActiveID}`
    )

    const findTotalEnogen = response.data.stewardship_activity.fields.filter(function(data) {
      return (data.field_id ==='TotalEnogenAcres' || data.field_id ==='total_enogen_acres_id')
    })
    const totalFieldsWithoutTotalEnogen = response.data.stewardship_activity.fields.filter(function(data) {
      return (data.field_id !=='TotalEnogenAcres' && data.field_id !=='total_enogen_acres_id')
    })

    if(response.data.stewardship_activity.fields.length > 1) {
      response.data.stewardship_activity.fields = response.data.stewardship_activity.fields.filter(function(data) {
        return (data.field_id !=='TotalEnogenAcres' && data.field_id !=='total_enogen_acres_id')
      })

      var newArr = response.data.stewardship_activity.fields.map(function (item) {
        if (item.planting_rate === null || item.planting_rate === 'null') {
          item.planting_rate = '0'
        }
        if (item.average_yield === null || item.average_yield === 'null') {
          item.average_yield = '0'
        }

        if(!item?.activity) {
          item.activity =
            {
              'field_lost_replant': {
                'notes': null,
                'acres': null,
                'replant': null,
                'field_lost_replant_date': null,
                'field_lost': null
              },
              'in_season_harvest_estimate': {
                'notes': null,
                'est_bu_acre': null,
                'planted_ac': null,
                'est_harvestable_ac': null,
                'est_total_production': null,
                'observation_date': null,
                'est_pollination_date': null
              },
              'harvest': {
                'total_harvest': null,
                'total_acres': null,
                'yield_per_acre': null,
                'unit_type': null,
                'harvest_date': null
              },
              'planting': {
                'date': null,
                'total_planted_acres': null,
                'planting_rate': null,
                'crop': null
              },
              'storage_cleanout': {
                'hatches_doors': null,
                'insect_rodent_care': null,
                'loading_augers_conveyers': null,
                'clean_out_date': null,
                'legs_distributors': null,
                'unloading_augers_conveyers': null,
                'next_crop': null,
                'bin_floors_walls': null,
                'previous_crop': null,
                'fans': null
              },
              'planting_cleanout': {
                'clean_out_date': null,
                'seed_transfer_carts': null,
                'seed_plates': null,
                'planter_make_model': null,
                'box_hopper': null,
                'next_crop': null,
                'pneumatic_system': null,
                'trucks_pickup_boxes': null,
                'auger_conveyers': null,
                'previous_crop': null
              },
              'harvest_cleanout': {
                'clean_out_date': null,
                'clean_off_feeder_hose': null,
                'combine_make_model': null,
                'clean_out_grain_tank': null,
                'open_clean_grain_and_tailing_elevators_to_remove_any_grain': null,
                'dryer_chambers': null,
                'previous_crop': null,
                'augers_conveyers': null,
                'open_and_clean_monitor_sensors': null,
                'trucker_hopper_boxes': null,
                'open_and_clean_rock_trap': null,
                'dryer_conveyer_equipment': null,
                'brush_off_outside_platforms_shields_engine_compartment': null,
                'next_crop': null,
                'check_walkers_threshing_for_loose_grain': null,
                'clean_off_header': null
              }
            }
        }
        return item
      })
      response.data.stewardship_activity.fields = [...newArr]
    }

    const stewardData = response.data.stewards.map(obj => {
      return {
        name: `${nullParser(obj.first_name)} ${nullParser(obj.last_name)}`,
        phone: formatPhoneNumber(nullParser(obj.phone)),
        email: nullParser(obj.email),
        id: obj.external_reference_id
      }
    })
    const activities = response.data.stewardship_activity
    let plantingData = activities.fields.map(obj => {
      return {
        name: obj.field_name,
        id: obj.field_id,
        total_planted_acres: obj.activity.planting?.total_planted_acres || '',
        date: convertDate(obj.activity.planting?.date) || '',
        planting_rate: obj.activity.planting?.planting_rate || '',
        crop: obj.activity.planting?.crop || '',
        type: 'planting'
      }
    })
    const harvestData = activities?.fields.map(obj => {
      return {
        name: obj.field_name,
        id: obj.field_id,
        total_acres: obj.activity.harvest?.total_acres || '',
        harvest_date: convertDate(obj.activity.harvest?.harvest_date) || '',
        yield_per_acre: obj.activity.harvest?.yield_per_acre || '',
        yield_per_acre_formatted: obj.activity.harvest?.yield_per_acre
          ? `${obj.activity.harvest?.yield_per_acre} ${
          obj.activity.harvest?.unit_type
            ? obj.activity.harvest?.unit_type === 'bushels'
              ? 'bu'
              : obj.activity.harvest.unit_type
            : ''
          }`
          : '',
        total_harvest: obj.activity.harvest?.total_harvest || '',
        total_harvest_formatted: obj.activity.harvest?.total_harvest
          ? `${obj.activity.harvest?.total_harvest} ${
          obj.activity.harvest.unit_type
            ? obj.activity.harvest?.unit_type === 'bushels'
              ? 'bu'
              : obj.activity.harvest?.unit_type
            : ''
          }`
          : '',
        type: 'harvest',
        unit_type: nullParser(obj.activity.harvest?.unit_type, 'bu')
      }
    })

    const storageData = activities.storage_locations.map((obj, index) => {
      const cleanout_date = obj.cleanout_date
        ? moment(obj.cleanout_date).format('YYYY-MM-DD')
        : ''
      return {
        ...obj,
        cleanout_date,
        type: 'storage',
        id: `${index}-${obj.location_name}`
      }
    })

    const responseContract = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?contract_id=${response.data.external_reference_id}`
    ) 

    let planting_count = -1     
    responseContract.data.contracts.contract_details.fields.forEach(obj => {
      planting_count = plantingData.findIndex(t=>t.id === obj.field_id)
      if(planting_count !== -1) {
        if(!plantingData[planting_count].name)
          plantingData[planting_count].name    = obj.field_name
        if(!plantingData[planting_count].total_planted_acres)
          plantingData[planting_count].total_planted_acres = obj.acres
          
        if(!plantingData[planting_count].planting_rate || plantingData[planting_count].planting_rate === null ||  plantingData[planting_count].planting_rate === 'null'){
          if(!obj.planting_rate || obj.planting_rate === null || obj.planting_rate === 'null'){
            plantingData[planting_count].planting_rate = '--'
          }
          else {
            plantingData[planting_count].planting_rate = obj.planting_rate
          }
        }
        if(!plantingData[planting_count].crop)
          plantingData[planting_count].crop = obj.average_yield
      }

      let harvest_count = -1
      harvest_count = harvestData.findIndex(t=>t.id === obj.field_id)
      if(harvest_count !== -1) {
        if(!harvestData[harvest_count].name)
          harvestData[harvest_count].name = obj.field_name
        if(!harvestData[harvest_count].total_acres)
          harvestData[harvest_count].total_acres = obj.acres
      }
    })


    let avgPlantingRate = 0
    let avgCrop = 0
    if(findTotalEnogen.length > 0) {
      avgPlantingRate = findTotalEnogen[0].planting_rate
      avgCrop = findTotalEnogen[0].average_yield
    } else {
      if(totalFieldsWithoutTotalEnogen.length > 0) {
        const fieldsPlantRateAndYield = plantingData.filter(field =>
          parseFloat(field.planting_rate) > 0 && parseFloat(field.crop) > 0
        )
        if(fieldsPlantRateAndYield.length > 0) {
          const totalPlantingRate = fieldsPlantRateAndYield.reduce((acc, field) => acc + parseFloat(field.planting_rate), 0)
          const totalAverageYield = fieldsPlantRateAndYield.reduce((acc, field) => acc + parseFloat(field.crop), 0)
          const averagePlantingRate = totalPlantingRate / fieldsPlantRateAndYield.length
          const averageAverageYield = totalAverageYield / fieldsPlantRateAndYield.length
          avgPlantingRate = averagePlantingRate
          avgCrop = averageAverageYield
        }
      }
    }

    plantingData = plantingData.map(obj => {
      return {
        ...obj,
        planting_rate: obj?.planting_rate > 0 ? obj?.planting_rate : avgPlantingRate || '',
        crop: obj?.crop > 0 ? obj?.crop : avgCrop || ''
      }
    })

    const originalResponse = response
    return {
      originalResponse,
      stewardData,
      plantingData,
      harvestData,
      storageData,
      activities
    }
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getStewardshipActivities = async (id, _param) => {
  let param = _param ? _param : 'external_reference_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/activity?${param}=${id}`
    )
    return response.data.activities
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const deleteAssignment = async (user_id, company_id) => {
  try {
    await axios.delete(
      `${ADDRESS}/company-management/${VERSION}/assignments?user_id=${user_id}&company_id=${company_id}`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const patchStewardshipTable = async (
  stewardshipActiveID,
  stewardshipActivityObj
) => {
  try {
    return await axios.patch(
      `${ADDRESS}/seed-stewardship/${VERSION}/activity?stewardship_activity_id=${stewardshipActiveID}`,
      stewardshipActivityObj
    )
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const patchStewardshipHistoryData = async (
  contractID,
  data
) => {
  try {
    return await axios.patch(
      `${ADDRESS}/grower-contracts/${VERSION}/contract-stewardship-history?contract_id=${contractID}`,
      { stewardship_history: data }
    )
  } catch (error) {
    console.error('error: ', error)
    return null
  }
}

export const postCommittedUnits = async postable => {
  try {
    const response = await axios.post(
      `${ADDRESS}/grain-ops/${VERSION}/committed-unit`,
      postable
    )
    return response.data
  } catch (error) {
    console.error('POST Committed Units: ', error)
    return null
  }
}

export const getCommittedUnits = async (id, param) => {
  const _param = param ? param : 'production_plan_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/committed-unit?${_param}=${id}&get_with_calculation=true`
    )
    let committedUnits = []
    response.data.committed_units.forEach(obj => {
      committedUnits = [...committedUnits, ...obj.committed_units]
    })
    return committedUnits
  } catch (error) {
    console.error('GET committed units: ', error)
    return null
  }
}

export const getContractCommittedUnits = async (id, param) => {
  const _param = param ? param : 'production_plan_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/committed-unit?${_param}=${id}`
    )
    let committedUnits = []
    response.data.committed_units.forEach(obj => {
      let total_contract_units = 0
      let total_harvest_bushels = 0
      obj.committed_units.forEach(obj1 => {
        total_contract_units += obj1.contract_units
        total_harvest_bushels += obj1.harvest_bushels
      })
      obj.committed_units.forEach(obj2 => {
        obj2.harvest_bushels = Math.round((obj2.contract_units / total_contract_units) * total_harvest_bushels)
      })
      committedUnits = [...committedUnits, ...obj.committed_units]
    })
    response.data.child_plans.forEach(obj2 => {
      obj2.monthly_units.forEach(obj3 => {
        const objNew = {
          'delivery_type':obj3.end_product_type,
          'delivery_month':obj3.month,
          'delivery_year':obj3.year,
          'contract_acres':obj3.child_plan_acres,
          'contract_units':obj3.child_plan_units,
          'harvest_bushels':0
        }
        committedUnits = [...committedUnits, objNew]
      })
    })
    return committedUnits
  } catch (error) {
    console.error('GET committed units: ', error)
    return null
  }
}

export const getCompanyUsers = async (key, value) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/users?${key}=${value}`
    )
    return {
      user_id: response.data.user_id,
      email: nullParser(response.data.email),
      first: nullParser(response.data.first),
      last: nullParser(response.data.last),
      phone: nullParser(response.data.phone),
      invite_complete: response.data.invite_complete
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

export const patchUser = async payload => {
  try {
    return await axios.patch(
      `${ADDRESS}/company-management/${VERSION}/users`,
      payload
    )
  } catch (error) {
    console.error('error: ', error)
  }
}

export const getContractsForMultipleCompanies = async companies_array => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?external_reference_id=${companies_array}`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getAssignmentsByUserId = async user_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/assignments?user_id=${user_id}`
    )
    return response.data.assignments.map(assignment => {
      return assignment.company_id
    })
  } catch (error) {
    console.error('GET ASSIGNMENTS BY USER ID: ', error)
    return null
  }
}

export const getDocuSignEmbed = async (
  contract_id,
  contract_signer_id,
  returnUrl
) => {
  try {
    const encodedUrl = encodeURIComponent(`${REACT_APP_URL}${returnUrl}`)
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/docusign-embed?contract_id=${contract_id}&contract_signer_id=${contract_signer_id}&returnUrl=${encodedUrl}`
    )
    return response.data.data.url
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const postStorageLocation = async postable => {
  try {
    const response = await axios.post(
      `${ADDRESS}/storage-locations/${VERSION}`,
      postable
    )
    return response.data
  } catch (error) {
    console.error('POST Storage: ', error)
    return null
  }
}

export const getStorage = async (key, val) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/storage-locations/${VERSION}?${key}=${val}`
    )
    return response
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getLinkCompanies = async companyId => {
  try {
    let response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}/link?company_id=${companyId}`
    )
    if (response.data?.companies) {
      response = response.data.companies.map(item => {
        return {
          type: nullParser(item.company_type),
          name: nullParser(item.company_name),
          city: nullParser(item.city),
          phone: item.phone,
          id: item.company_id,
          companyInfo: {
            id: item.company_id,
            name: nullParser(item.company_name)
          }
        }
      })
    }
    return response
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const postLinkCompanies = async postable => {
  try {
    const response = await axios.post(
      `${ADDRESS}/company-management/${VERSION}/link`,
      postable
    )
    return response.data
  } catch (error) {
    console.error('POST Link Companies: ', error)
    return null
  }
}

export const deleteLinkCompanies = async (deleteID, deleteFromID) => {
  try {
    return await axios.delete(
      `${ADDRESS}/company-management/${VERSION}/link?company_id_1=${deleteFromID}&company_id_2=${deleteID}`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getAllContractsYears = async () => {
  try {
    return await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/contract_year`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getAllfilteredContractYears = async (year, limit, contract_status) => {
  try {
    const response = await axios.get(
      contract_status && year ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&year=${year}&contract_status=${contract_status}` : year ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&contract_year=${year}` : contract_status ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&contract_status=${contract_status}` :
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last ? contract.contract_details.grower_details.last : '')}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getAllLinkedContractYears = async (year, limit, contract_status,production_plan) => {
  try {
    const response = await axios.get(
      contract_status && year ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&year=${year}&selected_contract_status=${contract_status}&selected_production_plan_id=${production_plan}&production_plan_id_and_status=true` : year ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&year=${year}&selected_contract_status=pendinggrowersigned,amendment_pending,amendmentpendinggrowersigned,completed,amendment_completed,voided,pending&selected_production_plan_id=${production_plan}&production_plan_id_and_status=true` : contract_status ? 
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&selected_contract_status=${contract_status}&selected_production_plan_id=${production_plan}&production_plan_id_and_status=true` :
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}&selected_production_plan_id=${production_plan}&production_plan_id_and_status=true`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last ? contract.contract_details.grower_details.last : '')}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getAllContracts = async limit => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}?limit=${limit}`
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last ? contract.contract_details.grower_details.last : '')}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getContractsByNameOrSAP = async value => {
  try {
    let response
    const regex = /^\d{2}[a-zA-Z]{3}.{9,11}$/
    if (regex.test(value)) {
      response = await axios.get(
        `${ADDRESS}/grower-contracts/${VERSION}?new_contract_id=${value}`
      )
    }
    else if (value.substring(0, 2) === '00' && value.length >= 10) {
      response = await axios.get(
        `${ADDRESS}/grower-contracts/${VERSION}?grower_sap_id=${value}`
      )
    } else {
      const grower_data = await axios.get(
        `${ADDRESS}/grower-360/${VERSION}/search?grower_name=${value}`
      )
      const grower_sap_id = grower_data.data && grower_data.data.growers && grower_data.data.growers[0].sap_id? grower_data.data.growers[0].sap_id : null
      if(grower_sap_id) {
        response = await axios.get(
          `${ADDRESS}/grower-contracts/${VERSION}?grower_sap_id=${grower_sap_id}`
        )
      } else {
        response = await axios.get(
          `${ADDRESS}/grower-contracts/${VERSION}?grower_name=${value}`
        )
      }
      
    }
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        sap_id: contract.contract_details.grower_details.sap_id,
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getScaleTickets = async (id, param) => {
  const _param = param ? param : 'production_plan_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?${_param}=${id}`
    )
    return response.data.scale_tickets.map(ticket => {
      return {
        grower_name: ticket.grower_name,
        original_new_contract_id: ticket.original_new_contract_id?ticket.original_new_contract_id:ticket.original_production_plan_inventory_code,
        scale_ticket_id: ticket.scale_ticket_id,
        scale_ticket_date: ticket.scale_ticket_date,
        scale_ticket_number: ticket.scale_ticket_number,
        gross_quantity: ticket.gross_quantity,
        net_quantity: ticket.net_quantity,
        test_weight: ticket.test_weight,
        moisture: ticket.moisture,
        damage: ticket.damage,
        foreign_material: ticket.foreign_material,
        rapid_visco_analyzer: ticket.rapid_visco_analyzer,
        gross_weight: ticket.gross_lbs,
        bill_of_lading: ticket.bill_of_landing_number,
        tare_weight: ticket.tar_lbs ? ticket.tar_lbs : '0',
        net_weight: ticket.net_lbs,
        created: ticket.created,
        notes: ticket.notes? ticket.notes : '-'
      }
    })
  } catch (error) {
    const errorMessage = JSON.parse(error?.response?.request.response)?.errors[0]
      .message
    if (
      errorMessage === 'scale ticket with not found with the given parameters'
    ) {
      return []
    }
    console.error('error ', error)
    return null
  }
}

export const getScaleTicketsByIdOrName = async value => {
  try {
    const responseById = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?scale_ticket_number=${value}`
    )
    const scaleTicketsByIdArray = responseById.data.scale_tickets_and_production_plan.map(ticket => {
      return {
        grower_name: ticket.scale_ticket.grower_name,
        scale_ticket_id: ticket.scale_ticket.scale_ticket_id,
        scale_ticket_date: moment(ticket.scale_ticket.scale_ticket_date).format('DD-MM-YYYY'),
        scale_ticket_number: ticket.scale_ticket.scale_ticket_number,
        net_quantity: ticket.scale_ticket.net_quantity,
        production_plan_year: ticket.production_plan.contract_year,
        grain_receiver: ticket.production_plan.company_name,
        gross_quantity: ticket.scale_ticket.gross_quantity,
        test_weight: ticket.scale_ticket.test_weight,
        moisture: ticket.scale_ticket.moisture,
        damage: ticket.scale_ticket.damage,
        foreign_material: ticket.scale_ticket.foreign_material,
        rapid_visco_analyzer: ticket.scale_ticket.rapid_visco_analyzer,
        bill_of_lading: ticket.scale_ticket.bill_of_landing_number,
        created: ticket.scale_ticket.created,
        gross_weight: ticket.scale_ticket.gross_lbs,
        tare_weight: ticket.scale_ticket.tar_lbs,
        net_weight: ticket.scale_ticket.net_lbs
      }
    })
    const responseByName = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?grower_name=${value}`
    )
    const scaleTicketsByNameArray = responseByName.data.scale_tickets_and_production_plan.map(ticket => {
      return {
        grower_name: ticket.scale_ticket.grower_name,
        scale_ticket_id: ticket.scale_ticket.scale_ticket_id,
        scale_ticket_date: moment(ticket.scale_ticket.scale_ticket_date).format('DD-MM-YYYY'),
        scale_ticket_number: ticket.scale_ticket.scale_ticket_number,
        net_quantity: ticket.scale_ticket.net_quantity,
        production_plan_year: ticket.production_plan.contract_year,
        grain_receiver: ticket.production_plan.company_name,
        gross_quantity: ticket.scale_ticket.gross_quantity,
        test_weight: ticket.scale_ticket.test_weight,
        moisture: ticket.scale_ticket.moisture,
        damage: ticket.scale_ticket.damage,
        foreign_material: ticket.scale_ticket.foreign_material,
        rapid_visco_analyzer: ticket.scale_ticket.rapid_visco_analyzer,
        bill_of_lading: ticket.scale_ticket.bill_of_landing_number,
        created: ticket.scale_ticket.created,
        gross_weight: ticket.scale_ticket.gross_lbs,
        tare_weight: ticket.scale_ticket.tar_lbs,
        net_weight: ticket.scale_ticket.net_lbs
      }
    })
    return [...scaleTicketsByIdArray, ...scaleTicketsByNameArray]
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const deleteScaleTicket = async (production_plan_id, scale_ticket_id) => {
  try {
    await axios.delete(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?production_plan_id=${production_plan_id}&scale_ticket_id=${scale_ticket_id}`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const shouldThisPass = async (arg, timeLimit) => {
  const response = await new Promise(res => {
    setTimeout(
      () => {
        if (arg === false) {
          res(null)
        }
        res(arg)
      },
      timeLimit ? timeLimit : 3000
    )
  })
  return response
}

export const getGrowersFromProdPlan = async searchVal => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/v1/es-production-plan?production_plan_id=${searchVal}`)
    return response
  } catch (error) {
    console.error('grower from prod plan error: ', error)
    return null
  }
}

export const getGrowersNamesFromProdPlan = async searchVal => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/v1?production_plan_id=${searchVal}&limit=1000`)
    return response
  } catch (error) {
    console.error('grower from prod plan error: ', error)
    return null
  }
}

export const postScaleTicket = async scaleTicketArray => {
  try {
    return await axios.post(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket`, scaleTicketArray
    )
  } catch (error) {
    console.error('Error posting scale ticket', error)
    return error.response
  }
}

export const patchScaleTicket = async (scaleTicketArray, scale_ticket_id, production_plan_id) => {
  try {
    return await axios.patch(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?production_plan_id=${production_plan_id}&scale_ticket_id=${scale_ticket_id}`, 
      scaleTicketArray
    )
  } catch (error) {
    console.error('Error updating scale ticket', error)
    return error.response
  }
}

export const postUnplannedTransfer = async scaleTicketArray => {
  try {
    return await axios.post(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket`, scaleTicketArray
    )
  } catch (error) {
    console.error('Error posting scale ticket', error)
    return error.response
  }
}

export const getSalesYear = async () => {
  try {
    return await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/sales-year`)
  } catch (error) {
    console.error('sales-year: ', error)
    return null
  }
}

export const patchSalesYear = async sales_year => {
  try {
    return await axios.patch(
      `${ADDRESS}/grain-ops/${VERSION}/sales-year`, { sales_year }
    )
  } catch (error) {
    console.error('Error posting sales year', error)
    return error.response
  }
}

export const getPlantingHarvestDate = async selected_year => {
  try {
    return await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/planting-and-harvest-date?selected_year=${selected_year}`)
  } catch (error) {
    console.error('Planting Harvest Date: ', error)
    return null
  }
}

export const postPlantingHarvestDate = async data => {
  try {
    return await axios.post(
      `${ADDRESS}/seed-stewardship/${VERSION}/planting-and-harvest-date`, data
    )
  } catch (error) {
    console.error('Error posting Planting Harvest Date', error)
    return error.response
  }
}

export const patchPlantingHarvestDate = async (data, id) => {
  try {
    return await axios.patch(
      `${ADDRESS}/seed-stewardship/${VERSION}/planting-and-harvest-date?planting_and_harvest_date_id=${id}`, data
    )
  } catch (error) {
    console.error('Error patching Planting Harvest Date', error)
    return error.response
  }
}

export const getAllPlantingHarvestDate = async () => {
  try {
    return await axios.get(
      `${ADDRESS}/seed-stewardship/${VERSION}/planting-and-harvest-date`)
  } catch (error) {
    console.error('Planting Harvest Date: ', error)
    return null
  }
}

export const postCompanyTraining = async bulkTraining => {
  try {
    return await axios.post(
      `${ADDRESS}/grower-training/${VERSION}/company-training?upload=true`, bulkTraining
    )
  } catch (error) {
    console.error('Error posting scale ticket', error)
  }
}
export const getTraining = async (sap_id, contract_year) => {
  try {
    return await axios.get(
      `${ADDRESS}/grower-training/${VERSION}/company-training?company_sap_id=${sap_id}&training_year=${contract_year}`)
  } catch (error) {
    console.error('get training: ', error)
    return null
  }
}

export const postCheckedStatus = async data => {
  try {
    return await axios.post(
      `${ADDRESS}/grower-training/${VERSION}/company-training`, data
    )
  } catch (error) {
    console.error('Error posting status data', error)
    return error.response
  }
}

export const patchCheckedStatus = async data => {
  try {
    return await axios.patch(
      `${ADDRESS}/grower-training/${VERSION}/company-training`, data
    )
  } catch (error) {
    console.error('Error patch status data', error)
    return error.response
  }
}

export const patchDeleteCompany = async (contract_id, data) => {
  try {
    return await axios.patch(
      `${ADDRESS}/grower-contracts/${VERSION}`,
      { 
        contract_id, 
        deleted_user_info: data
      }
    )
  } catch (error) {
    console.error('error: ', error)
  }
}

export const patchDeleteScaleTicket = async scaleTicketData => {
  try {
    return await axios.delete(
      `${ADDRESS}/grain-ops/${VERSION}/scale-ticket?multiple=true`,
      { data:scaleTicketData }
    )
  } catch (error) {
    console.error('error: ', error)
  }
}

export const getGrowersNamesFromProdPlanUnplanned = async searchVal => {
  try {
    const response =  await axios.get(
      `${ADDRESS}/grower-contracts/v1?production_plan_id=${searchVal}&unplanned_transfer=true&limit=1000`,
      { timeout: 5000 }
    )
    const filterRes = response.data.contracts.filter(x => (x.contract_state === 'completed' || x.contract_state === 'amendment_completed'))
    return filterRes
  } catch (error) {
    console.error('grower from prod plan error: ', error)
    throw new Error('Timeout')
  }
}

export const getGrowersNamesFromSearchUnplanned = async (searchTerm, searchCategory, year) => {
  let growerNameVal = ''
  let newContractVal = ''
  if(searchCategory === 'grower_name') {
    growerNameVal = searchTerm
  } else if(searchCategory === 'new_contract_id') {
    newContractVal = searchTerm
  }
  try {
    return await axios.get(
      `${ADDRESS}/grower-contracts/v1?searh_by_grower_name_and_new_id=false&grower_name_search=${growerNameVal}&new_contract_id=${newContractVal}&year=${year}`
    )
  } catch (error) {
    console.error('grower from search error: ', error)
  }
}

export const getContractFromResellerId = async (year, limit, contract_status,resellerCompany) => {
  const body = { 
    companyList: resellerCompany
  } 
  try {
    const response = await axios.post(
      contract_status && year ? 
      `${ADDRESS}/grower-contracts/${VERSION}/companies_contract?limit=${limit}&year=${year}&contract_status=${contract_status}` : year ? 
      `${ADDRESS}/grower-contracts/${VERSION}/companies_contract?limit=${limit}&contract_year=${year}` : contract_status ? 
      `${ADDRESS}/grower-contracts/${VERSION}/companies_contract?limit=${limit}&contract_status=${contract_status}` :
      `${ADDRESS}/grower-contracts/${VERSION}/companies_contract?limit=${limit}`, 
      body
    )
    return response.data.contracts.map(contract => {
      return {
        contract_id: contract.contract_id,
        external_reference_id: contract.external_reference_id,
        contract_year: moment(contract.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contract.contract_details.grower_details.first
        )} ${nullParser(contract.contract_details.grower_details.last ? contract.contract_details.grower_details.last : '')}`,
        reseller: nullParser(
          contract.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contract.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contract.contract_state),
        created_date: moment(contract.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contract.new_contract_id)
      }
    })
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getArchivePdfContracts = async contract_id => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/archive-pdf-contracts?contract_id=${contract_id}&get_pdf=true`
    )
    return response.data
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getSupportiveLanguage = async sapId => {
  try {
    return await axios.get(
      `${ADDRESS}/company-management/${VERSION}/supported-languages`
    )
  } catch (error) {
    console.error('searchCompaniesBySAP:', error)
    return null
  }
}

export const postAssignFields = async (contract_id, fields, sfdcId, plantingData) => {
  let responseEluminateField = []
  try {
    responseEluminateField = await axios.get(
      `${ADDRESS}/grower-fields/${VERSION}/fields-eluminate?grower_salesforce_id=${sfdcId}`
    )
    responseEluminateField = responseEluminateField.data.fields
  } catch (error) {
    console.error('error: ', error)
  }

  let responseGrowMore = []
  try {
    responseGrowMore = await axios.get(
      `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdcId}`
    )
    responseGrowMore = responseGrowMore.data.fields
  } catch (error) {
    console.error('error: ', error)
  }

  let axiosArray = []
  if(fields?.fields && fields?.fields.length > 0 && responseEluminateField && responseEluminateField.length > 0 && responseGrowMore && responseGrowMore.length > 0) {
    const fieldsVal = fields.fields
    fieldsVal.forEach(f=>{
      if(!responseGrowMore.find(field => ((f.field_id === field.field_id) && (f.field_id !== 'total_enogen_acres_id')))) {
        const filterData = responseEluminateField.find(field => ((f.field_id === field.field_id) && (f.field_id !== 'total_enogen_acres_id')))
        if (filterData) {
          let newPromise = axios({
            method: 'post',
            url: `${ADDRESS}/grower-fields/${VERSION}?grower_salesforce_id=${sfdcId}`,
            data: filterData
          })
          axiosArray.push(newPromise)
        } 
      }
    })
  }

  if (plantingData.length > 0 && fields?.fields.length > 0) {
    plantingData.forEach(obj1 => {
      const correspondingField = fields.fields.find(obj2 => obj2.field_id === obj1.field_id)
      if (correspondingField) {
        correspondingField.activity = obj1.activity
      } 
    })

    const updatedFields = fields.fields.map(obj => {
      if (!Object.prototype.hasOwnProperty.call(obj, 'activity')) {
        obj.activity = {
          field_lost_replant: {
            acres: null,
            notes: null,
            field_lost_replant_date: null,
            replant: null,
            field_lost: null
          },
          in_season_harvest_estimate: {
            notes: null,
            est_bu_acre: null,
            planted_ac: null,
            est_harvestable_ac: null,
            est_total_production: null,
            observation_date: null,
            est_pollination_date: null
          },
          harvest: {
            unit: null,
            total_acres: null,
            notes: null,
            harvest_date: null,
            total_harvest: null,
            yield_per_acre: null,
            crop: null
          },
          planting: {
            date: null,
            total_planted_acres: null,
            planting_rate: null,
            notes: null,
            crop: null
          },
          storage_cleanout: {
            hatches_doors: null,
            insect_rodent_care: null,
            loading_augers_conveyers: null,
            clean_out_date: null,
            legs_distributors: null,
            unloading_augers_conveyers: null,
            next_crop: null,
            bin_floors_walls: null,
            previous_crop: null,
            fans: null
          },
          planting_cleanout: {
            clean_out_date: null,
            seed_transfer_carts: null,
            seed_plates: null,
            planter_make_model: null,
            box_hopper: null,
            next_crop: null,
            pneumatic_system: null,
            trucks_pickup_boxes: null,
            auger_conveyers: null,
            previous_crop: null
          },
          harvest_cleanout: {
            clean_out_date: null,
            clean_off_feeder_hose: null,
            combine_make_model: null,
            clean_out_grain_tank: null,
            open_clean_grain_and_tailing_elevators_to_remove_any_grain: null,
            dryer_chambers: null,
            previous_crop: null,
            augers_conveyers: null,
            open_and_clean_monitor_sensors: null,
            trucker_hopper_boxes: null,
            open_and_clean_rock_trap: null,
            dryer_conveyer_equipment: null,
            brush_off_outside_platforms_shields_engine_compartment: null,
            next_crop: null,
            check_walkers_threshing_for_loose_grain: null,
            clean_off_header: null
          }
        }
      }
      return obj
    })
    
    fields = {
      ...fields,
      fields: [...updatedFields]
    }
  }

  if(axiosArray.length > 0) {
    axios
      .all(axiosArray)
      .then(() => { 
        axios.patch(
          `${ADDRESS}/grower-contracts/${VERSION}/update-contract-fields?contract_id=${contract_id}`,
          fields
        ).then(response => {
          return response.data
        })
      })
      .catch(error => {
        console.error('error: ', error)
        return null
      })
  } else {
    try {
      return await axios.patch(
        `${ADDRESS}/grower-contracts/${VERSION}/update-contract-fields?contract_id=${contract_id}`,
        fields
      )
    } catch (error) {
      console.error('error: ', error)
      return null
    }
  }
}

export const getLanguageByCompany = async (companyId, supported_language) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/v1?company_id=${companyId}`
    )
    const company_supported_languages = nullParser(response.data.supported_languages)
    const returnData = supported_language.filter(x=> company_supported_languages.indexOf(x.lang_value) !== -1)
    return returnData
  } catch (error) {
    console.error('GET Language: error ', error)
    return null
  }
}
export const syncCompany = async params => {
  try {
    return await axios.post(
      `${ADDRESS}/platform-integrations/${VERSION}/salesforce-sync-companies`,
      params
    )
  } catch (error) {
    console.error('Error in sync company: ', error)
    return error.response
  }
}

export const syncContract = async contractId => {
  try {
    return await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/trigger-contracts?contract_id=${contractId}`
    )
  } catch (error) {
    console.error('Error in sync contract: ', error)
    return error.response
  }
}

export const postTrainingVideo = async params => {
  try {
    return await axios.post(
      `${ADDRESS}/grower-training/${VERSION}/`,params)
  } catch (error) {
    console.error('Error in Video Uploading: ', error)
    return error.response
  }
}

export const patchTrainingVideo = async (params, videoId) => {
  try {
    return await axios.patch(
      `${ADDRESS}/grower-training/${VERSION}?training_id=${videoId}`,params)
  } catch (error) {
    console.error('Error in Video Uploading: ', error)
    return error.response
  }
}

export const deleteTrainingVideo = async videoId => {
  try {
    return await axios.delete(
      `${ADDRESS}/grower-training/${VERSION}?training_id=${videoId}`
    )
  } catch (error) {
    console.error('error ', error)
    return null
  }
}

export const getMultiContractsByProdPlanIds =  async ( payload,limit,offset ) => {
  try {
    return await axios.post(
      `${ADDRESS}/grower-contracts/${VERSION}/search-by-production-plan?limit=${limit}&offset=${offset}`,
      payload
    )
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}
export const getMultiProductionPlans =  async prodPlanIds  => {
  try {
    return await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/production-plan?production_plan_id=${prodPlanIds}&multi_plans=true`
    )
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}
export const getProgram = async year => {
  try {
    return await axios.get(
      `${ADDRESS}/company-management/${VERSION}/programs?skip=0&limit=500`
    )
  } catch (error) {
    console.error('Error to GET program', error)
    return null
  }
}

export const getProgramAssignments = async (programId, _param) => {
  _param =  _param ? _param : 'program_id'  
  try {
    return await axios.get(
      `${ADDRESS}/company-management/${VERSION}/program-assignments?${_param}=${programId}`
    )
  } catch (error) {
    console.error('Error to GET program', error)
    return null
  }
}



export const postProgram = async payload => {
  try {
    return await axios.post(
      `${ADDRESS}/company-management/${VERSION}/programs`,payload)
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}

export const patchProgram = async (payload) => {
  try {
    return await axios.patch(
      `${ADDRESS}/company-management/${VERSION}/programs`, payload)
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}

export const deleteProgram = async programId => {
  try {
    return await axios.delete(
      `${ADDRESS}/company-management/${VERSION}/programs?program_id=${programId}`
    )
  } catch (error) {
    console.error('error ', error)
    return error.response
  }
}

export const postProgramAssignments = async payload => {
  try {
    return await axios.post(
      `${ADDRESS}/company-management/${VERSION}/program-assignments`,payload)
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}
export const deleteProgramAssignments = async assignmentId => {
  try {
    return await axios.delete(
      `${ADDRESS}/company-management/${VERSION}/program-assignments?assignment_id=${assignmentId}`)
  } catch (error) {
    console.error('Error in add program: ', error)
    return error.response
  }
}

export const getVideoByYear = async year => {
  try {
    return await axios.get(
      `${ADDRESS}/grower-training/v1?training_id=Enogen-Stewardship-${year}`
    )
  } catch (error) {
    console.error('Error to GET video', error)
    return null
  }
}

export const verifyAccountLeads =  data =>{
  return axios.post(
    `${ADDRESS}/company-management/v1/update-eal-accounts?validate=true`,data)
}

export const saveAccountLeads = async payloadData => {
  
  const limit = 10
  const batches = []
  const { assignment_list } = payloadData

  for (let i = 0; i < assignment_list.length; i += limit) {
    batches.push(assignment_list.slice(i, i + limit))
  }

  const promises = []
  
  for (let batch of batches) {
    const currentData = { assignment_list: batch }
      
    promises.push(
      axios.post(`${ADDRESS}/company-management/v1/update-eal-accounts?submit=true`, currentData)
        .then(response => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          return { success: false, error: error.message }
        })
    )
  }
  
  try {
    const results = await Promise.all(promises)

    const consolidatedSuccessAssignments = []
    const consolidatedFailureAssignments = []
 
    results.forEach(result => {
      if (result.success) {
        consolidatedSuccessAssignments.push(...result.data.success_assignments)
        consolidatedFailureAssignments.push(...result.data.failuer_assignments)
      } else {
        console.error(result.error)
      }
    })
 
    return {
      ...results,
      success_assignments: consolidatedSuccessAssignments,
      failuer_assignments: consolidatedFailureAssignments
    }
    
  } catch (error) {
    return error
  }
}

export const getContractWithComId = async (company_id, limit) => {
  try {
    const response = await axios.get(
      `${ADDRESS}/grower-contracts/${VERSION}/search?limit=${limit}&global_search=${company_id}`
    )
    return response
  } catch (error) {
    console.error('error ', error)
    return error
  }
}

export const getCommittedUnitsForContract = async (id) => {
  const _param =  'production_plan_id'
  try {
    const response = await axios.get(
      `${ADDRESS}/grain-ops/${VERSION}/committed-unit?${_param}=${id}`
    )
    return response
  } catch (error) {
    console.error('GET committed units: ', error)
    return null
  }
}

export const getCompaniesAdminDetail = async()=>{
  try {
    const response = await axios.get(
      `${ADDRESS}/company-management/${VERSION}?get_companies_admin_details=true`
    )
    return response
  } catch (error) {
    console.error('error ', error)
    return error
  }
}